import React, { useState, useEffect } from 'react'
import { Button, Table, FormControl, OverlayTrigger, Tooltip, Collapse } from 'react-bootstrap'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'
import { DetailedCustomer } from '../container-components/DetailedCustomer'
import { DetailedOrder } from '../container-components/DetailedOrder'
import { NewCustomer } from './NewCustomer'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { useFilterCustomers, useSearchFilter } from '../presentational-components/filterutils'
import { FetchBoutiqueB2COrderTransactions, FetchReadCustomers, FetchSalutations } from '../../fetcher'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'


const CustomerManagement = () => {
    const [showModal, setShowModal] = useState(false)
    const handleCloseModal = () => setShowModal(false)
    const handleShowModal = () => setShowModal(true)
    const [taskName, setTaskName] = useState("Lade Kundenverwaltung...")

    const [showCustomer, setShowCustomer] = useState(false)
    const [customerUpdated, setCustomerUpdated] = useState(false)
    const handleCloseCustomer = () => setShowCustomer(false)
    const handleShowCustomer = () => setShowCustomer(true)

    const [showOrder, setShowOrder] = useState(false)
    const handleCloseOrder = () => setShowOrder(false)
    const handleShowOrder = () => setShowOrder(true)

    const [customers, setCustomers] = useState([])
    const [customerOrders, setCustomerOrders] = useState([])
    const [salutations, setSalutations] = useState([])
    const [customerToUpdate, setCustomerToUpdate] = useState({ Contact: {Name: ""} })
    const [orderToView, setOrderToView] = useState({ order: null, article: null, name: "" })
    const { filterCustomersBySearchInput } = useFilterCustomers()

    const openModal = (e) => {
        e.preventDefault()
        handleShowModal()
    }

    const openUpdateCustomer = (e, customer) => {
        e.preventDefault()
        e.stopPropagation()

        setCustomerToUpdate(customer)
        handleShowCustomer()
    }

    const openOrder = (e, order, article, name) => {
        e.preventDefault()
        e.stopPropagation()

        setCustomerToUpdate(customers.find(x => x.ContactSysId === order.ContactSysId))
        setOrderToView({ order, article, name })

        handleShowOrder()
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const controller = new AbortController()
    const signal = controller.signal

    useEffect(() => {
        FetchReadCustomers(setCustomers, openAlert, signal, "CustomerManagement")
    }, [])

    useEffect(() => {
        FetchSalutations(setSalutations, openAlert, signal, "CustomerManagement")
    }, [])

    useEffect(() => {
        console.log("FetchBoutiqueB2COrderTransactions")
        FetchBoutiqueB2COrderTransactions(setCustomerOrders, null, openAlert, null, signal, "CustomerManagement")
    }, [])

    const reload = () => {
        FetchReadCustomers(setCustomers, openAlert, signal, "CustomerManagement")
        FetchSalutations(setSalutations, openAlert, signal, "CustomerManagement")
        FetchBoutiqueB2COrderTransactions(setCustomerOrders, null, openAlert, null, signal, "CustomerManagement")
    }

    useEffect(() => {
        console.log("orderToView")
        console.log(orderToView)
        if (orderToView.order !== null && orderToView.order.ContactSysId !== undefined && orderToView.order.ContactSysId !== null) {
            let tempCustomer = customers.find(x => x.ContactSysId == orderToView.order.ContactSysId)
            console.log("reload orderToView", orderToView, tempCustomer)
            setOrderToView({ ...orderToView, name: tempCustomer.Contact.Name + ", " + tempCustomer.Contact.Surname })
            setCustomerToUpdate(tempCustomer)
        }
    }, [customers])

    const [expandedRows, setExpandedRows] = useState([])

    const expandRow = (e, index) => {
        const expandedRowsCopy = [...expandedRows]
        expandedRowsCopy.includes(index) ? expandedRowsCopy.splice(expandedRowsCopy.indexOf(index), 1) : expandedRowsCopy.push(index)
        setExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedRow = (index) => {
        return (expandedRows.includes(index))
    }

    const [filteredCustomers, setFilteredCustomers] = useState([])
    const [sortedCustomers, setSortedCustomers] = useState([])
    const { searchInput, handleSearchInput } = useSearchFilter()

    useEffect(() => {
        setFilteredCustomers([...customers])
        setSortedCustomers([...customers])
    }, [customers])

    useEffect(() => {
        let filteredCustomers = filterCustomersBySearchInput(sortedCustomers, searchInput)
        setFilteredCustomers(filteredCustomers)
    }, [searchInput, sortedCustomers])

    const filteredElements = () => {
        return (
            filteredCustomers.map((entry, index) =>
                <>
                    <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, entry.ContactSysId)} aria-expanded={getIsExpandedRow(entry.ContactSysId)} aria-controls={entry.AbstractTransactionSysId}>
                        <td>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>Kunden bearbeiten</Tooltip>}>
                                <a className="edit-button" onClick={(e) => openUpdateCustomer(e, entry)}>&#9998;</a>
                            </OverlayTrigger>
                        </td>
                        {getIsExpandedRow(entry.ContactSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                        <td className="mainColumn">{entry.Contact.Name}</td>
                        <td className="mainColumn">{entry.Contact.Surname}</td>
                        <td className="mainColumn">{EnumValueTranslations(entry.Contact.Salutation)}</td>
                        <td className="mainColumn">{entry.Contact.Email}</td>
                        <td className="mainColumn">{entry.Contact.Phone}</td>
                        <td className="mainColumn"></td>
                        <td className="mainColumn">{entry.Name}{(entry.Name && entry.Surname) ? ", " : ""}{entry.Surname}</td>
                        <td className="mainColumn">{EnumValueTranslations(entry.Salutation)}</td>
                        <td className="mainColumn">{entry.Street}</td>
                        <td className="mainColumn">{entry.HouseNumber}</td>
                        <td className="mainColumn">{entry.City}</td>
                        <td className="mainColumn">{entry.PostalCode}</td>
                        <td className="mainColumn">{entry.Country}</td>
                        <td className="mainColumn">{entry.AdditionalLines !== undefined ? entry.AdditionalLines[0] : ""}</td>
                        <td className="mainColumn">{entry.AdditionalLines !== undefined ? entry.AdditionalLines[1] : ""}</td>
                        <td></td>
                    </tr>

                    <Collapse in={getIsExpandedRow(entry.ContactSysId)} timeout={30}>
                        <td colSpan="6" className="td-nomargin">
                            <div id={entry.ContactSysId} className="salesBoutique-child-div">
                                <thead className="sticky-table-header">
                                    <tr className="salesboutique-childheaderrow">
                                        <th></th>
                                        <th className="mainColumn">Datum</th>
                                        <th className="mainColumn">Verkaufsstelle</th>
                                        <th className="mainColumn">Zahlungsmethode</th>
                                        <th className="mainColumn">Bestellstatus</th>
                                        <th className="mainColumn">Bearbeitungsstatus</th>
                                        <th className="mainColumn">Bemerkung (Artikel)</th>
                                        <th className="mainColumn">Anzahl</th>
                                        <th className="mainColumn">Designername</th>
                                        <th className="mainColumn">Artikel ID</th>
                                        <th className="mainColumn">Artikelname</th>
                                        <th className="mainColumn">Größe</th>
                                        <th className="mainColumn">Farbe</th>
                                        <th className="mainColumn">Einzelpreis</th>
                                        <th className="mainColumn">Preisänderung</th>
                                        <th className="mainColumn">Gesamtpreis</th>
                                        <th className="mainColumn">Anzahlung</th>
                                        <th className="mainColumn">Bemerkung (Bestellung)</th>
                                    </tr>
                                </thead>
                                {customerOrders.filter(x => x.ContactSysId === entry.ContactSysId).length === 0 && "Für diesen Kunden liegen keine Bestellungen vor."}
                                {customerOrders.filter(x => x.ContactSysId === entry.ContactSysId).sort((a, b) => a.Date - b.Date).reverse().map(order =>
                                    order.SoldArticles.map(article => 
                                        <>
                                            <tr>
                                                <td>
                                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Bestellung öffnen</Tooltip>}>
                                                        <a className="edit-button" onClick={(e) => openOrder(e, order, article, entry.Contact.Name + ", " + entry.Contact.Surname)}>&#9998;</a>
                                                    </OverlayTrigger>
                                                </td>
                                                <td className="mainColumn">{order.Date}</td>
                                                <td className="mainColumn">{order.PointOfOrdering}</td>
                                                <td className="mainColumn">{EnumValueTranslations(order.Payment)}</td>
                                                <td className="mainColumn">{EnumValueTranslations(article.OrderState.OrderState)}</td>
                                                <td className="mainColumn">{EnumValueTranslations(article.OrderProcessingState.OrderProcessingState)}</td>
                                                <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(article.Remark)}>
                                                    <td className="dropdown-article-description mainColumn">{article.Remark}</td>
                                                </OverlayTrigger>
                                                <td className="numberColumn">{article.Count}</td>
                                                <td className="mainColumn">{article.DesignerName}</td>
                                                <td className="mainColumn">{article.ArticleIdFaex}</td>
                                                <td className="mainColumn">{article.ArticleName}</td>
                                                <td className="mainColumn">{article.Size}</td>
                                                <td className="mainColumn">{article.Colour}</td>
                                                <td className="numberColumn">{parseFloat(article.PriceUnit).toFixed(2).replace('.', ',') + "€"}</td>
                                                <td className="numberColumn">{parseFloat((-1) * (parseFloat(article.PriceUnit) - parseFloat(article.PriceAtTimeOfSale))).toFixed(2).replace('.', ',') + "€"}</td>
                                                <td className="numberColumn">{parseFloat(article.Count * parseFloat(article.PriceAtTimeOfSale)).toFixed(2).replace('.', ',') + "€"}</td>
                                                <td className="numberColumn">{parseFloat(article.Count * parseFloat(article.PrepaymentAtTimeOfSale)).toFixed(2).replace('.', ',') + "€"}</td>
                                                <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(order.InitialRemark)}>
                                                    <td className="dropdown-article-description mainColumn">{order.InitialRemark}</td>
                                                </OverlayTrigger>
                                            </tr>
                                        </>
                                    )
                                )}
                            </div>
                        </td>
                    </Collapse>
                </>)
        )
    }

    return (
        <div>
            <div className="tablet-center">
                <h1>Kundenverwaltung</h1>
                <div className="flex-linebreak"></div>
                <Button variant="secondary" className="form" onClick={openModal}>Neuen Kunden hinzufügen</Button>
            </div>
           
            <div className="flex-linebreak"></div>

            <div className="inline">
                <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
            </div>

            <div className="tablet-transactions">
                <Table className='table table-striped-immediate' aria-labelledby="tabelLabel" size="sm">
                    <thead className="sticky-table-header">
                        <tr>
                            <th className="mainColumn" colSpan={2}></th>
                            <th className="mainColumn" colSpan={6}>Kontakt</th>
                            <th className="mainColumn" colSpan={9}>Lieferadresse</th>
                        </tr>
                        <tr>
                            <th className="mainColumn"></th>
                            <th className="mainColumn"></th>
                            <th className="mainColumn">Name
                            </th>
                            <th className="mainColumn">Vorname
                            </th>
                            <th className="mainColumn">Anrede
                            </th>
                            <th className="mainColumn">E-Mail
                            </th>
                            <th className="mainColumn">Telefonnummer
                            </th>
                            <th className="mainColumn">
                            </th>
                            <th className="mainColumn">Name, Vorname
                            </th>
                            <th className="mainColumn">Anrede
                            </th>
                            <th className="mainColumn">Straße
                            </th>
                            <th className="mainColumn">Hausnummer
                            </th>
                            <th className="mainColumn">Stadt
                            </th>
                            <th className="mainColumn">PLZ
                            </th>
                            <th className="mainColumn">Land
                            </th>
                            <th className="mainColumn">Zusatz 1
                            </th>
                            <th className="mainColumn">Zusatz 2
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredElements()}
                    </tbody>

                </Table>
            </div>

            <ModalComponent handleShow={showModal} handleClose={handleCloseModal} reload={reload}
                modalTitle="Neuen Kunden hinzufügen" modalBody={<NewCustomer salutations={salutations.Salutations} handleCloseModal={handleCloseModal} openAlert={openAlert} />} formTitle="create-customer-form" />
            <ModalComponent handleShow={showCustomer} handleClose={handleCloseCustomer} reload={reload}
                modalTitle={"Kunden bearbeiten: '" + customerToUpdate.Contact.Name + ", " + customerToUpdate.Contact.Surname + "'"}
                modalBody={<DetailedCustomer customerToUpdate={customerToUpdate} salutations={salutations.Salutations} handleCloseCustomer={handleCloseCustomer} openAlert={openAlert} />} formTitle="update-customer-form" />
            <ModalComponent handleShow={showOrder} handleClose={handleCloseOrder} reload={reload}
                modalTitle={"Bestellung bearbeiten: "}
                modalBody={<DetailedOrder customerOrder={orderToView} handleOpenCustomer={handleShowCustomer} handleCloseOrder={handleCloseOrder} openAlert={openAlert} />} formTitle="update-order-form" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            <LoadingSpinner task={taskName} area={"CustomerManagement"} />

        </div>
    )
}

export { CustomerManagement }